export const TASK_OVERFLOW = 74;
export const ROUTE_USER_OVERFLOW = 53;
export const ROUTE_USER_TASK_OVERFLOW = 231;

export enum TASK_STATUS {
	DONE = 'DONE',
	SKIPPED = 'SKIPPED',
	TO_DO = 'TO_DO', // Assigned
	UNASSIGNED = 'UNASSIGNED',
	UNCOMPLETED = 'UNCOMPLETED',
	IN_PROGRESS = 'IN_PROGRESS',
}

export const COLOR_STATUS_MAP: Record<TASK_STATUS, string> = {
	DONE: '#32A960',
	TO_DO: '#329AFF',
	IN_PROGRESS: '#329AFF',
	SKIPPED: '#8C8C8C',
	UNASSIGNED: '#FBBC4C',
	UNCOMPLETED: '#FF4D4E',
};

type StatusTags = {
	color: string;
	labelKey: string;
	ribbon: string;
};
export const TASK_STATUS_TAGS: Record<TASK_STATUS, StatusTags> = {
	DONE: { color: 'success', labelKey: 'doneTask', ribbon: COLOR_STATUS_MAP.DONE },
	TO_DO: { color: 'processing', labelKey: 'assigned', ribbon: COLOR_STATUS_MAP.TO_DO },
	IN_PROGRESS: { color: 'processing', labelKey: 'assigned', ribbon: COLOR_STATUS_MAP.IN_PROGRESS },
	SKIPPED: { color: 'default', labelKey: 'skipped', ribbon: COLOR_STATUS_MAP.SKIPPED },
	UNASSIGNED: { color: 'warning', labelKey: 'unassigned', ribbon: COLOR_STATUS_MAP.UNASSIGNED },
	UNCOMPLETED: { color: 'error', labelKey: 'uncompletedTasks', ribbon: COLOR_STATUS_MAP.UNCOMPLETED },
};

export const STANDARD_DATE_FORMAT = 'YYYY-MM-DD';
export const AMERICAN_DATE_FORMAT = 'DD-MM-YYYY';
export const YEAR_MONTH_DAY_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';
export const YEAR_MONTH_DAY_TIME_WITH_MILISECONDS_FORMAT = 'YYYY-MM-DD HH:mm:ss.SSS';
export const UTC_FORMAT = 'YYYY-MM-DDTHH:mm:ss.SSS[Z]';
export const REPORT_FORMAT = 'YYYY-MM-DD HH:mm:ss';
export const RABBIT_UTC_FORMAT = 'YYYY-MM-DDTHH:mm:ss';
export const LAST_REPORTED_DATE_TIME_FORMAT = 'MMM D, YYYY, h:mm A';
export const YEAR_MONTH_DAY_MIDNIGHT_FORMAT = 'YYYY-MM-DDT00:00:00';
export const TIME_FORMAT = 'HH:mm:ss';
export const HOUR_MINUTE_SECOND_FORMAT = 'hh:mm A';

export const START_OF_DAY_STANDARD_FORMAT = 'YYYY-MM-DD 00:00:00';
export const END_OF_DAY_STANDARD_FORMAT = 'YYYY-MM-DD 23:59:59';

// Map limits to avoid it from navigating into blank tiles
export const MAP_BOUNDS_EDGES = {
	north: 85,
	south: -85,
	east: 180,
	west: -180,
};

export const MAP_RESTRICTED_ZOOM = {
	minZoom: 3,
	maxZoom: 20,
};

export enum SpeedLimitService {
	OFF = 'OFF',
	HERE = 'HERE',
}

export enum EnumBehaviors {
	ENTER = 0,
	LEAVE = 1,
	ENTER_AND_LEAVE = 2,
	REMAIN_IN_AREA = 3,
	SPEED_CONTROL = 4,
}

export const behaviorAlertOptions = [
	{ value: EnumBehaviors.ENTER, translationKey: 'enter' },
	{ value: EnumBehaviors.LEAVE, translationKey: 'leave' },
	{ value: EnumBehaviors.ENTER_AND_LEAVE, translationKey: 'enterAndLeave' },
	{ value: EnumBehaviors.REMAIN_IN_AREA, translationKey: 'remainInArea' },
	{ value: EnumBehaviors.SPEED_CONTROL, translationKey: 'speedControl' },
];
